import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { X, Printer } from 'lucide-react';
import { useAuth } from '../../AuthContext';
import { normaliseSpecial } from './specialLogic';
import { SpecialReportViewWithFetch } from './SpecialReportView';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const SpecialReportModal = ({ data, patient: patientProp, sessionId, onClose }) => {
  const { user } = useAuth();
  const [patient, setPatient] = useState(patientProp);
  const state = normaliseSpecial(data);

  useEffect(() => {
    let alive = true;
    (async () => {
      if (patientProp?.mrd || !sessionId) return;
      try {
        const sr = await axios.get(`${API}/sessions/${sessionId}`);
        const pid = sr.data?.patient_id;
        if (!pid || !alive) return;
        const pr = await axios.get(`${API}/patients/${pid}`);
        if (alive) setPatient(pr.data);
      } catch { /* fallback */ }
    })();
    return () => { alive = false; };
  }, [sessionId, patientProp]);

  useEffect(() => {
    document.body.classList.add('printing-special-report');
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const onKey = (e) => { if (e.key === 'Escape') onClose?.(); };
    window.addEventListener('keydown', onKey);
    return () => {
      document.body.classList.remove('printing-special-report');
      document.body.style.overflow = prev;
      window.removeEventListener('keydown', onKey);
    };
  }, [onClose]);

  return (
    <div className="fixed inset-0 z-[100] bg-slate-900/70 flex flex-col" data-testid="special-report-modal">
      <div className="special-report-toolbar flex items-center justify-between px-4 py-2 bg-white border-b border-slate-300 flex-shrink-0">
        <h2 className="text-sm font-bold text-slate-800">Audiometric Special Tests Report Preview</h2>
        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={() => window.print()}
            data-testid="special-report-print-btn"
            className="inline-flex items-center gap-1 px-3 py-1 text-xs font-bold bg-slate-800 hover:bg-slate-900 text-white rounded shadow-sm"
          ><Printer size={12} /> Print</button>
          <button
            type="button"
            onClick={onClose}
            data-testid="special-report-close-btn"
            className="inline-flex items-center gap-1 px-2.5 py-1 text-xs font-bold bg-slate-100 hover:bg-slate-200 text-slate-700 rounded"
          ><X size={12} /> Close</button>
        </div>
      </div>
      <div className="flex-1 overflow-auto py-6 flex justify-center bg-slate-200">
        <div style={{ boxShadow: '0 6px 24px rgba(15,23,42,0.15)' }}>
          <SpecialReportViewWithFetch
            state={state}
            patient={patient}
            sessionId={sessionId}
            audiologistName={state.clinician || user?.name || 'Audiologist'}
          />
        </div>
      </div>
    </div>
  );
};

export default SpecialReportModal;
